<div class="container" [uiClipType]="enClipType" >
  <img [src]="imageUrl" (error)="swapImage($event.target)" />
</div>